import { HiOutlineBriefcase } from 'react-icons/hi2';
import { LuGlobe } from 'react-icons/lu';
import { UserRoundIcon } from 'wisestep-base';

import { IOption } from '../../../components/SettingsIndex';

export const automationsNavigationOptions: IOption[] = [
  {
    label: 'Jobs',
    icon: <HiOutlineBriefcase />,
    url: '/automation/jobs',
  },
  {
    label: 'Candidate',
    icon: <UserRoundIcon />,
    url: '/automation/candidates',
  },
  {
    label: 'Submission',
    icon: <LuGlobe />,
    url: '/automation/submissions',
  },
];
